export class TipoServico {
    id: string;
    nome: string;
}

export enum TipoServicoEnum {
    SOAP = 'SOAP',
    REST = 'REST'
}